import { FC } from 'react';
import { SText } from '@setvi/shared/components';
import { LabelValueFieldCard } from './styled';
import { ILabelValueField } from '../../../../types';
import {
  BaseLabelFieldCard,
  BaseLabelValueFieldRow,
  BaseLabelValueFieldCard
} from '../../../../styled';

interface OriginalLabelValueFieldProps {
  field: ILabelValueField;
}

export const OriginalLabelValueField: FC<OriginalLabelValueFieldProps> = ({
  field
}) => (
  <LabelValueFieldCard>
    {field.data.map(({ value, label }, index) => (
      <BaseLabelValueFieldRow key={`${label}-${index + 1}`}>
        <BaseLabelFieldCard>
          <SText title={label} weight="normal" size="sm" />
        </BaseLabelFieldCard>

        <BaseLabelValueFieldCard>
          <SText noLineClamp title={value} weight="semibold" size="sm" />
        </BaseLabelValueFieldCard>
      </BaseLabelValueFieldRow>
    ))}
  </LabelValueFieldCard>
);
